import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import useWebData from '../hooks/useWebData';
import { useEffect } from 'react';
import useActiveNavbar from '../hooks/useActiveNavbar';
import { faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { faFacebook, faInstagram, faSquareXTwitter } from '@fortawesome/free-brands-svg-icons';

const Footer = () => {
    const { webData }: any = useWebData();

    const { setSelected }: any = useActiveNavbar();
    const location = useLocation();

    useEffect(() => {
        setSelected(location.pathname);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const hideHeaderForPaths = "/create-pdf";
    if (hideHeaderForPaths.endsWith(location.pathname)) {
        return <></>;
    }

    const callPhone = (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
        window.location.href = `tel:${webData?.websitePhone.replaceAll("-", "")}`;
        e.preventDefault();
    }

    const sendEmail = (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
        window.location.href = `mailto:${webData?.websiteEmail}`;
        e.preventDefault();
    }

    document.getElementById("favicon")?.setAttribute("href", webData?.favIcon);
    const titleElement = document.getElementById("title");
    if (titleElement) {
        titleElement.innerText = webData?.companyName ?? '';
    }

    if (
        location.pathname.replace("/", "").includes("carrental/reservations/print-quote")
        || location.pathname.replace("/", "").includes("public/booking/rental-agreement")
    ) {
        return <></>
    }

    return (
        <footer className="py-10 px-6 md:px-16 bg-[#111827] text-white"
            style={{
                backgroundColor: webData?.websiteFooterColor,
                color: webData?.websiteFooterSubColor
            }}
        >
            <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-8">
                {/* Company Info */}
                <div>
                    <Link to="/" onClick={() => setSelected("/")}>
                        <img
                            className="logo-img h-24 w-24 max-w-full mx-auto lg:mx-0 mb-3"
                            //change from dynamic logo to static
                            //src={webData?.tentantLogo}
                            src="/images/jjvanslogo.png"
                            alt="logo"
                        />
                    </Link>
                    <p className="text-sm">
                        Your trusted partner for reliable and affordable car rentals. Explore the road with confidence.
                    </p>
                </div>

                {/* Navigation Links */}
                <div>
                    <h3 className="text-lg font-semibold text-white mb-4">Quick Links</h3>
                    <ul className="space-y-2 text-sm">
                        <li><NavLink to="/" onClick={() => setSelected("/")} className="hover:text-white hover:border-b hover:border-white">Home</NavLink></li>
                        <li><NavLink to="/fleet" onClick={() => setSelected("/fleet")} className="hover:text-white hover:border-b hover:border-white">Fleet</NavLink></li>
                        <li><NavLink to="/about-us" onClick={() => setSelected("/about-us")} className="hover:text-white hover:border-b hover:border-white">About Us</NavLink></li>
                        <li><NavLink to="/contact-us" onClick={() => setSelected("/contact-us")} className="hover:text-white hover:border-b hover:border-white">Contact</NavLink></li>
                    </ul>
                </div>

                {/* Contact Info */}
                <div>
                    <h3 className="text-lg font-semibold text-white mb-4">Contact Us</h3>
                    <ul className="space-y-3 text-sm">
                        <li className="flex items-center gap-2 cursor-pointer" onClick={callPhone}>
                            <FontAwesomeIcon icon={faPhone} /> {webData?.websitePhone}
                        </li>
                        <li className="flex items-center gap-2 cursor-pointer" onClick={sendEmail}>
                            <FontAwesomeIcon icon={faEnvelope} /> {webData?.websiteEmail}
                        </li>
                    </ul>
                </div>

                {/* Social Media */}
                <div>
                    <h3 className="text-lg font-semibold text-white mb-4">Follow Us</h3>
                    <div className="flex gap-4 text-white text-xl">
                        <NavLink to={webData?.facebookUrl || "#"} target='_blank' rel='noopener noreferrer' className="hover:text-blue-500"><FontAwesomeIcon icon={faFacebook} /></NavLink>
                        <NavLink to={webData?.twitterUrl || "#"} target='_blank' rel='noopener noreferrer' className="hover:text-sky-400"><FontAwesomeIcon icon={faSquareXTwitter} /></NavLink>
                        <NavLink to={webData?.instagramUrl || "#"} target='_blank' rel='noopener noreferrer' className="hover:text-pink-500"><FontAwesomeIcon icon={faInstagram} /></NavLink>
                    </div>
                </div>
            </div>

            {/* Bottom Bar */}
            <div className="mt-10 border-t border-gray-700 pt-4 text-center text-sm text-gray-500">
                © {new Date().getFullYear()} <Link to="/" className='hover:cursor-pointer hover:underline'>{webData?.companyName}</Link> All rights reserved.
            </div>
        </footer>
    )
}
export default Footer;